export default __webpack_public_path__ + "static/media/502.7f28bcb4.gif";